<template>
    <!-- This component is used on the product page of a particular tyre -->
    <div>
        <div class="bg-navy rounded p-2">
            <div class="p-2 rounded bg-white d-flex align-items-center">
                <b class="w-100 quantity-label">How many tyres do you need?</b>
                <select name="quantity" id="quantity" class="form-select" v-model="quantity">
                    <option v-for="index in 5" :key="index" :value="index">{{ index }}</option>
                </select>
            </div>
            <div class="p-2 mt-2 rounded bg-white d-flex align-items-center">
                <div class="col-8">
                    <b class="price">&pound;{{ tyre.fully_fitted_price }}</b>&nbsp;<small>per tyre</small>
                    <br>
                    <b class="route-type">Fully fitted</b> - <small class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top" title="Fully fitted price includes VAT, delivery, fitting, balancing and disposal charges"><u>what's included?</u></small>
                </div>
                <div class="col-4">
                    <button
                        class="btn btn-primary w-100"
                        @click="this.changeRouteAddToBasket(tyre.st_code, 0)"
                        v-if="parseInt(tyreStock.total_stock) >= minimumStockRequired"
                    >
                        Add to order
                    </button>
                    <div v-else>
                        <p class="mb-0 text-center">Out of stock</p>
                    </div>
                </div>
            </div>
            <div class="p-2 mt-2 rounded bg-white d-flex align-items-center">
                <div class="col-8">
                    <b class="price">&pound;{{ tyre.home_delivery_price }}</b>&nbsp;<small>per tyre</small>
                    <br>
                    <b class="route-type">Tyre delivery</b> - <small class="cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top" title="Delivered to your home or work in 3-5 working days. Delivery cost calculated at checkout"><u>what's included?</u></small>
                </div>
                <div class="col-4">
                    <button
                        class="btn btn-primary w-100"
                        @click="this.changeRouteAddToBasket(tyre.st_code, 1)"
                        v-if="parseInt(tyreStock.home_delivery_stock) >= minimumStockRequired"
                    >
                        Add to order
                    </button>
                    <div v-else>
                        <p class="mb-0 text-center">Out of stock</p>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="showPaypal">
            <div
                v-if="updatedPaypalPrice >= 30"
                class="bg-navy px-3 py-2 my-3 rounded d-none d-sm-block"
                data-pp-style-logo-position="top"
                data-pp-message
                :data-pp-amount="updatedPaypalPrice"
                data-pp-placement="product"
                data-pp-style-layout="text"
                data-pp-style-text-size="16"
                data-pp-style-text-color="white"
            ></div>
            <div
                v-if="updatedPaypalPrice >= 30"
                class="bg-navy px-3 py-2 mb-3 mt-2 mt-sm-0 rounded d-block d-sm-none"
                data-pp-style-logo-position="top"
                data-pp-message
                data-pp-placement="category"
                data-pp-style-layout="text"
                data-pp-style-text-size="12"
                data-pp-style-text-color="white"
            ></div>
        </template>
        <div class="p-4" :style="bannerBackgroundStyle">
            <div class="col-6">
                <div class="banner-content" :class="banners[0]?.dark_desktop_banner == 1 ? 'text-light' : 'text-dark'" v-if="banners[0]" v-html="banners[0].content "></div>
            </div>
        </div>
        <br>
        <teleport to="body">
            <basket-modal :postcode="postcode" :basket="updatedBasket" :modal-open="modalOpen" @closeModal="modalOpen = false" @basketUpdated="basketUpdated"></basket-modal>
            <upsell-modal
                :current-tyre="currentTyre"
                :upsold-tyre="upsoldTyre"
                :upsell-details="upsellDetails"
                :upsell-modal-open="upsellModalOpen"
				:image-base-path="tyreImagePath"
                @closeModal="upsellModalOpen = false"
            ></upsell-modal>
        </teleport>
    </div>
</template>

<script>
    import basket from '@shared/mixins/basket';

    export default {
        props: [
            'tyre',
            'homeDeliverySession',
            'basket',
            'banners',
            'showPaypal',
            'tyreImagePath',
            'brandImagePath',
            'ppPrice',
            'postcode',
            'tyreStock',
            'minimumStockRequired'
        ],
        emits: ['basket-updated', 'modalOpen'],
        mixins: [basket],
        data() {
            return {
	            updatedBasket: this.basket,
                homeDelivery: (this.homeDeliverySession == 1 ? true : false),
	            modalOpen: false,
            }
        },
        mounted() {
            if(typeof(this.$gtag) !== 'undefined') {
                this.$gtag.event('view_item', {
                    currency: "GBP",
                    value: this.tyre.retail,
                    items: [
                        {
                            "item_id": this.tyre['st_code'],
                            "item_brand" : this.tyre['brand'],
                            "item_name" : this.tyre['description'],
                            "price": this.tyre['retail'],
                            "quantity": 1
                        }
                    ]
                });
            }
            else {
                console.log('gtag not loaded');
            }
        },
        methods: {
	        openModal() {
	        	this.modalOpen = true;
	        },
	        basketUpdated: function(data) {
	        	this.updatedBasket = data;
			},
            async changeRouteAddToBasket(st_code, homeDelivery) {
                var response = await axios.post('/ajax/toggle_home_delivery_route/' + homeDelivery);

                this.addTyreToBasket(st_code, this.quantity);
            }
        },
        computed: {
            bannerBackgroundStyle() {
                var bannerUrl = typeof(this.banners[0]) != 'undefined' ? this.banners[0].brand_mobile_image_url : null;
                var object = 'background: url(' + (bannerUrl) + ') no-repeat; background-size: cover; background-position: center center;';
                
                return object;
            },
            updatedPaypalPrice() {
                return this.quantity * this.ppPrice;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #quantity {
        max-width: 60px;
    }
    .price {
        font-size: 25px;
    }
    .route-type {
        font-size: 16px;
    }
    .quantity-label {
        font-size: 20px;
    }
</style>